import * as React from "react";

const TextArea = React.forwardRef(
  ({ className, isRequired, label, hasError, inputActions, ...props }, ref) => {
    return (
      <div>
        <div className="flex justify-between items-center mb-2">
          {label && (
            <label className="text-gray-600 font-semibold">
              {label} {isRequired && <span className="text-red-600">*</span>}
            </label>
          )}
          {inputActions && <div className="shrink-0">{inputActions}</div>}
        </div>

        <textarea
          className={`flex min-h-[80px] w-full text-gray-900 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 disabled:cursor-not-allowed disabled:opacity-50 ${className} ${
            hasError ? "border-red-500 focus:ring-red-500" : "border-gray-300"
          }`}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);
TextArea.displayName = "TextArea";

export { TextArea };
